'use client';

import { LinkPagination } from '@components/pagination';

interface PressPaginationProps {
  currentPage: number;
  totalPages: number;
  category: string;
}

export function PressPagination({
  currentPage,
  totalPages,
  category,
}: PressPaginationProps) {
  const generatePageUrl = (page: number): string => {
    if (category === 'latest') {
      if (page === 1) {
        // For page 1 of latest, use the main press page
        return '/press';
      } else {
        // For other pages of latest, use the paginated route
        return `/press/page/${page}`;
      }
    } else {
      if (page === 1) {
        // For page 1, use the main topic page
        return `/press/topic/${category}`;
      } else {
        // For other pages, use the paginated route
        return `/press/topic/${category}/page/${page}`;
      }
    }
  };

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="flex justify-center mt-12">
      <LinkPagination
        totalPages={totalPages}
        currentPage={currentPage}
        generatePageUrl={generatePageUrl}
        navAriaLabel="Press pagination"
        pagesAriaLabel="Go to page"
      />
    </div>
  );
}
